import { Card, Layout, SkeletonBodyText, SkeletonPage } from '@shopify/polaris';
import React from 'react';
import styled from 'styled-components';

const SkeletonWrapper = styled.div`
  display: flex;
  justify-content: center;
  .no-shadow-card {
    margin: 0 10px;
    box-shadow: none;
    border: 0.1rem solid #f0f0f6;
  }

  .view-loading-parent {
    height: 100vh;
    width: 100vh;
  }
`;

const CustomFormLoading = () => {
  return (
    <SkeletonWrapper>
      <div className="view-loading-parent">
        <SkeletonPage>
          <Layout>
            <Layout.Section>
              <Card sectioned>
                <SkeletonBodyText />
              </Card>
              <Card sectioned>
                <SkeletonBodyText />
              </Card>
              <Card sectioned>
                <SkeletonBodyText />
              </Card>
            </Layout.Section>
          </Layout>
        </SkeletonPage>
      </div>
    </SkeletonWrapper>
  );
};

export default CustomFormLoading;
